import { candlePatternBuilder } from "./candlePattern/candlePatternBuilder";

export const individualTacticTriggeredBuilderMap = {
  CANDLE_PATTERN: candlePatternBuilder
}